<div class="block @container">
  <div class="flex flex-col @3xl:flex-row gap-x-3 gap-y-5 items-start @3xl:items-center">
    <div class="flex-1 flex gap-3 items-center w-full">
      <ui-skeleton class="hidden @3xl:block h-10 w-[78px] rounded-md" />
      <div class="flex-1 grid grid-cols-1 @3xl:grid-cols-3 gap-3 items-center">
        <ui-skeleton class="h-10 w-full rounded-md" />
        <ui-skeleton class="h-10 w-full rounded-md hidden @3xl:inline" />
        <ui-skeleton class="h-10 w-full rounded-md hidden @3xl:inline" />
      </div>
      <ui-skeleton class="block @3xl:hidden h-10 w-10 rounded-md" />
    </div>
    <div class="flex gap-1 items-center">
      <ui-skeleton class="block rounded-full h-6 w-11" />
      <ui-skeleton class="block rounded-full h-4 w-32" />
    </div>
  </div>
</div>
